import Background from "../frontend/Background";
import "./Payment.css";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AddressElement, Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { auth } from "../firebase/firebaseConfig";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { useAuthContext } from "../firebase/AuthContext";

function Payment() {
  const [clientSecret, setClientSecret] = useState("");
  const location = useLocation();
  const [paymentIntent, setPaymentIntent] = useState("");
  const [address, setAddress] = useState({});
  const [isAddressComplete, setIsAddressComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userLanguage } = useAuthContext();
  const navigate = useNavigate();

  const texts = {
    de: {
      continueWithPayment: "Mit Zahlung fortfahren",
    },
    en: {
      continueWithPayment: "Continue with Payment",
    },
  };

  const queryParams = new URLSearchParams(location.search);
  const priceId = queryParams.get("id");

  const handleAddressChange = (event) => {
    setAddress(event.value.address);
    setIsAddressComplete(event.complete);
  };

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://createcheckoutsession-ihg7hu5nyq-ew.a.run.app",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: auth.currentUser.uid,
            priceId: priceId,
            email: auth.currentUser.email,
            address: address,
          }),
        }
      );

      const { sessionId } = await response.json();
      const stripe = await stripePromise;

      await stripe.redirectToCheckout({ sessionId });
      setLoading(false);
    } catch (error) {
      console.error("Error redirecting to Checkout:", error);
      setLoading(false);
    }
  };

  const stripePromise = loadStripe(
    "pk_live_51QRbTaEiJZm6GgyMSs0gPs33zWzL2ZuHoyeFpVEhs4C0rnw1y7t8ePpAyw1wvAuXsl10bFcyzHcZ7LYwE2Y9p4IQ0035gr2c1d"
  );

  const options = {
    clientSecret: clientSecret,
    appearance: {
      theme: "flat",
    },
    loader: "auto",
  };

  return (
    <>
      <Background />
      <div className="payment">
        <div className="container">
          <Elements stripe={stripePromise}>
            <AddressElement
              onChange={handleAddressChange}
              options={{
                mode: "billing", // "shipping" für Lieferadressen
              }}
            />
            {!loading ? (
              <button onClick={handleCheckout} disabled={!isAddressComplete}>
                {texts[userLanguage]["continueWithPayment"]}
              </button>
            ) : (
              <div
                style={{
                  marginTop: "10px",
                  height: "60px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Logo
                  style={{
                    height: "100%",
                    animation: "rotate 2s linear infinite",
                  }}
                ></Logo>
              </div>
            )}
          </Elements>
        </div>
      </div>
    </>
  );
}

export default Payment;
